import { useStaticQuery, graphql } from "gatsby"
import React, { useEffect, useRef, useState } from "react"
import freeSample from "../../../assets/images/icon-free-sample.svg"
import useBrowserMode from "../../../hooks/useBrowserMode"
import useHomeLinkMode from "../../../hooks/useHomeLinkMode"
import useLocaleMode from "../../../hooks/useLocaleMode"
import {
  addNoScroll,
  removeNoScroll,
} from "../../../state/utils/overflowHelper"
import Lightbox from "../../organisms/lightbox/lightbox"
import "./navMenu.scss"

const NavMenu = props => {
  const lightBoxUsage = "countriesList";
  const node = useRef();
  const [listOpen, setCountriesState] = useState(false);
  const [fCloseClass, setClass] = useState("");
  const [isMenuActive, setMenuActive] = useState(false);
  const [navActive, setNavActive] = useState(null);
  const { homeLink } = useHomeLinkMode();
  const { isBrowser } = useBrowserMode();
  const { locale } = useLocaleMode();

  useEffect(() => {
    if (typeof window !== "undefined" && !navActive) {
      const url = window.location.pathname;
      const urlSplit = url.split("/");
      if (urlSplit.length > 1) {
        setNavActive(urlSplit[1])
      }
    }
  }, []);

  const query = useStaticQuery(graphql`
    query LOGO_SALE_MENU {
      allContentfulTenaHome {
        nodes {
          numeroDeWhatsApp
          compraEnLineaRedireccion
          node_locale
          compraEnLineaLogo {
            node_locale
            file {
              url
            }
            description
          }
        }
      }
      allContentfulTenaMenu(filter: { titulo: { eq: "Menú > Megamenú" } }) {
        nodes {
          opcionesMenu {
            nombre
            slug
            titulo
          }
          node_locale
        }
      }
    }
  `);
  const infoBuy =
    isBrowser &&
    query &&
      query.allContentfulTenaHome.nodes.filter(
        node => node.node_locale === locale
      )[0];
  const navMenuOptions =
    isBrowser &&
    query &&
      query.allContentfulTenaMenu.nodes.filter(
        node => node.node_locale === locale
      )[0];
  const toggleMenu = isMenuActive => {
    const menu = document.getElementById("f-header-burger-menu");
    if (isMenuActive) {
      setTimeout(() => {
        setMenuActive(false)
      });
      menu.className -= " f-header-burguer--active--fixed";
      removeNoScroll()
    } else {
      setMenuActive(true);
      addNoScroll();
      setTimeout(() => {
        menu.className += " f-header-burguer--active--fixed"
      }, 500)
    }
  };

  const openHideDropdown = () => {
    if (listOpen === false) {
      setCountriesState(true)
    } else {
      setClass("f-closed-dropdown");
      setTimeout(() => {
        setCountriesState(false);
        setClass("")
      }, 200)
    }
  };

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setClass("f-closed-dropdown");
    setTimeout(() => {
      setCountriesState(false);
      setClass("")
    }, 500)
  };

  useEffect(() => {
    if (listOpen) {
      document.addEventListener("mousedown", handleClickOutside)
    } else {
      document.removeEventListener("mousedown", handleClickOutside)
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      removeNoScroll()
    }
  }, [listOpen]);

  return (
    <>
      <button
        id="f-header-burger-menu"
        className={
          isMenuActive
            ? "f-header-burguer f-header-burguer--active"
            : "f-header-burguer"
        }
        type="button"
        onClick={() => {
          toggleMenu(isMenuActive)
        }}
      >
        <span
          className={
            isMenuActive
              ? "f-header-burguer__line f-header-burguer__line--active"
              : "f-header-burguer__line"
          }
        ></span>
        <span
          className={
            isMenuActive
              ? "f-header-burguer__line f-header-burguer__line--active"
              : "f-header-burguer__line"
          }
        ></span>
        <span
          className={
            isMenuActive
              ? "f-header-burguer__line f-header-burguer__line--active"
              : "f-header-burguer__line"
          }
        ></span>
      </button>
      <div
        className={
          isMenuActive
            ? "f-nav-menu-container f-nav-menu-container--active"
            : "f-nav-menu-container"
        }
      >
        {isMenuActive && <span className="f-menu-title">MENÚ</span>}
        {isMenuActive && (
          <div className="f-select-container">
            <p className="f-select-title">
              Te encuentras en <span>{props.countriesData.currentCountry}</span>
            </p>
            <div className="f-select-wrapper">
              <p ref={node} onClick={openHideDropdown}>
                Cambia de país
              </p>
            </div>
            {listOpen && (
              <Lightbox
                classToAdd={fCloseClass}
                lightBoxUsage={lightBoxUsage}
                countriesData={props.countriesData}
              />
            )}
          </div>
        )}
        {isBrowser && (
          <>
            <ul>
              {navMenuOptions.opcionesMenu.map((option, index) => {
                return (
                  <li key={index}>
                    <a
                      rel="noopener noreferrer"
                      target={
                        option.slug.includes("https:") ? "_blank" : "_self"
                      }
                      className={
                        "f-nav-link " +
                        (navActive === option.nombre.toLowerCase()
                          ? "nav-active"
                          : "")
                      }
                      href={
                        option.slug.includes("tel:") ||
                        option.slug.includes("https:")
                          ? option.slug
                          : homeLink + option.slug
                      }
                    >
                      {option.nombre}
                    </a>
                  </li>
                )
              })}
            </ul>
            <div className="f-bottom-wrapper">
              { locale === "es-CO" || locale === "es-PR" ? (
                <>
                {locale === "es-CO" ?
                  <a
                    className="f-nav-link-flow"
                    href={infoBuy.compraEnLineaRedireccion}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="f-nav-link-btn f-nav-link-btn-shoppingcart">
                      <p className="f-nav-link-btn-title">COMPRAR EN</p>
                      <img
                        src={infoBuy.compraEnLineaLogo.file.url}
                        alt="Carrito de compras"
                      />
                    </div>
                  </a>
                  : null}
                  <a
                    className="f-nav-link-flow"
                    href={homeLink + (locale === "es-CO" ? "muestra-gratis" : "pide-tu-muestra")}
                  >
                    <div className="f-nav-link-btn f-nav-link-btn-freesample">
                      {isMenuActive && (
                        <img src={freeSample} alt="Muestra" />
                      )}
                      {"es-CO" === locale || "es-PR" === locale ? (
                        <p className="f-nav-link-btn-title">{"es-PR" === locale ? "PIDE TU MUESTRA" :"MUESTRA GRATIS" }</p>
                      ) : "es-AR" === locale ? (
                        // <p className="f-nav-link-btn-title">PIDE TU MUESTRA</p>
                        <></>
                      ) : "es-BO" === locale ? (
                        <></>
                      ) : (
                        <></>
                      )}
                    </div>
                  </a>
                </>
              ) : null}
              <div className="f-footer-info-wrapper">
                <div className="f-footer-link">
                  <a
                    rel="noopener noreferrer"
                    href={homeLink + "nuestra-marca/"}
                  >
                    NUESTRA MARCA
                  </a>
                </div>
                <div className="f-footer-link">
                  <a rel="noopener noreferrer" href={homeLink + "contacto/"}>
                    CONTÁCTANOS
                  </a>
                </div>
                <div className="f-footer-link">
                  <a
                    rel="noopener noreferrer"
                    href={homeLink + "terminos-y-condiciones/"}
                  >
                    TÉRMINOS y CONDICIONES
                  </a>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
};

export default NavMenu
